<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.index')">Events
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.show', [eventInfo.id])">
                {{ eventInfo.name }}
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            <inertia-link class="text-indigo-400 hover:text-indigo-600"
                          :href="route('attendee-import.index', [eventInfo.id])">Import Attendees
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            Batch #{{ batch.id }}
        </h1>
        <form @submit.prevent="store">
            <steps class="mb-6" current-step="map" :batch-id="batch.id"></steps>

            <info-box>
                Please match each of the uploaded fields with a corresponding database field.
                Where possible, the database has attempted to automatically match fields it recognizes.
                Please review these decisions for accuracy.
                <br>
                When importing attendees with guests, use the "Attendee" column to indicate whether a field contains information
                specific for the primary attendee or one of their guests.
            </info-box>

            <table-wrapper :headers="['ID', 'Name', 'Label', 'Mapped Field', 'Attendee']" :text-wrap="false"
                           class="mb-4">
                <table-row v-for="field in form.fields" :key="field.id">
                    <table-cell>{{ field.id }}</table-cell>
                    <table-cell>{{ field.name }}</table-cell>
                    <table-cell :title="field.label">{{
                            truncate(field.label, {length: 40, separator: ' '})
                        }}
                    </table-cell>
                    <table-cell>
                        <select-input v-model="field.table_field" class="w-full">
                            <option></option>
                            <optgroup v-for="fieldGroup in fieldOptions" :label="fieldGroup.group"
                                      :key="fieldGroup.group">
                                <option v-for="field in fieldGroup.fields" :key="field" :value="field"
                                        v-text="field"></option>
                            </optgroup>
                        </select-input>
                    </table-cell>
                    <table-cell colspan="2">
                        <select-input v-model="field.record_index" class="w-full">
                            <option :value="0">Primary Attendee</option>
                            <option :value="1">Guest #1</option>
                            <option :value="2">Guest #2</option>
                            <option :value="3">Guest #3</option>
                            <option :value="4">Guest #4</option>
                        </select-input>
                    </table-cell>
                </table-row>
            </table-wrapper>

            <div class="mb-6 flex items-center">
                <button class="btn-red" tabindex="-1" type="button" @click="destroy">Delete Batch</button>
                <button class="btn-indigo ml-auto" type="button" @click="submit">
                    Continue
                </button>
            </div>
        </form>

    </div>
</template>

<script>
import Layout from "@/Shared/Layout"
import Icon from "@/Shared/Icon"
import TableWrapper from "@/Shared/Table/TableWrapper"
import TableRow from "@/Shared/Table/TableRow"
import TableCell from "@/Shared/Table/TableCell"
import TableCellEnd from "@/Shared/Table/TableCellEnd"
import SelectInput from '@/Shared/SelectInput'
import Steps from "./ImportSteps.vue"
import truncate from 'lodash/truncate'
import InfoBox from "../../Shared/InfoBox.vue";

export default {
    metaInfo: {title: "Header Match"},
    components: {
        InfoBox,
        Icon,
        TableWrapper,
        TableRow,
        TableCell,
        TableCellEnd,
        Steps,
        SelectInput,
    },
    layout: Layout,
    props: {
        eventInfo: Object,
        batch: Object,
        fieldOptions: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                fields: this.batch.fields,
            }),
        }
    },
    watch: {},
    methods: {
        truncate,
        destroy() {
            if (confirm('Are you sure you want to delete this attendee import batch?')) {
                this.$inertia.delete(this.route('attendee-import.destroy', [this.batch.id]))
            }
        },
        submit() {
            this.form.put(this.route('attendee-import-map.update', [this.batch.id]))
        }
    },
}
</script>
